import { snakeCase } from "change-case";

import { formatLocalizedCurrency } from "./localize-currency";

export function snakeCaseObjectKeys<T>(object: Record<string, T>) {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [snakeCase(key), value])
  );
}

export function getFormattedAmount({
  amount,
  lang,
}: {
  amount: number;
  lang: string;
}): string {
  return formatLocalizedCurrency(amount, lang, {
    maximumFractionDigits: 0,
  });
}

export function roundToLowerBand(number: number): number {
  if (number < 10) return number;

  const magnitude = Math.floor(Math.log10(number));
  const rounded = Math.floor(number / 10 ** magnitude) * 10 ** magnitude;
  return rounded;
}
